<script lang="ts">
    
    import type { Player } from "../../Model/Player";
    import AspectRatio from "../Shared/AspectRatio.svelte";
    import Picture from "../Shared/Picture.svelte";
    import Watch from "../Shared/Watch.svelte";
    import PlayerRankingPosition from "./PlayerRankingPosition.svelte";

    export let player: Player;

</script>

<AspectRatio ratio={1}>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="player-tap" on:click>
        <div class="picture">
            <PlayerRankingPosition let:rankingPosition>
                {#if rankingPosition}
                    <div class="ranking-position">
                        {rankingPosition.playerPosition}/{rankingPosition.numPlayers}
                    </div>
                {/if}
            </PlayerRankingPosition>
            <Picture id={player.pictureId} />
        </div>
        <div class="name">
            <Watch state={player.name} />
        </div>
    </div>
</AspectRatio>

<style lang="scss">

    .player-tap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
    }

    .picture {
        flex: 1 1 0;
        max-height: calc(100% - 1.5rem);
        max-width: calc(100% - 1.5rem);
        position: relative;

        :global(img) {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            border: 2px solid #fff;
        }
    }

    .ranking-position {
        position: absolute;
        top: 0;
        right: -4px;
        padding: 2px 4px;
        border-radius: 5000px;
        background-color: var(--color-secondary);
        color: #000;
        font-size: 0.6rem;
        font-weight: bold;
    }

    .name {
        font-size: 0.8rem;
    }

</style>
